var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"priority-tag"},[_c('span',{class:_vm.tagClass,attrs:{"title":_vm.tag}},[_vm._v(_vm._s(_vm.tag))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21dc922c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_modules/InvoiceScan/CellComp/TimeDueComp.vue
// module id = 6v8b
// module chunks = 12